/**
 * Keyed by the only ranking signal the frontend can see today (the client-side
 * `sortType` arm). This is an interim stand-in for a true ranking-version
 * identifier from the personalization pipeline — swap the key type here once
 * that identifier exists, without changing the fallback behavior below.
 */
export type RankingRationaleSignal = 'personalization' | 'recommended'

const RANKING_RATIONALE_MESSAGE_IDS: Partial<
  Record<RankingRationaleSignal, string>
> = {
  personalization: 'Common.Carousel.personalizedCategoryRationale',
}

/**
 * Returns the i18n message id for the approved rationale copy, or `undefined`
 * when the signal has no approved copy — callers must render no label in that
 * case rather than a stale or placeholder string.
 */
export function getRankingRationaleMessageId(
  signal: RankingRationaleSignal
): string | undefined {
  return RANKING_RATIONALE_MESSAGE_IDS[signal]
}
